import PropTypes from "prop-types";

import styles from "./styles/Modal.module.scss";
import classNames from "classnames";
import {CSSTransition} from "react-transition-group";


const ModalBackdrop = (props) => {
    const {active, backgroundColor, onMouseDown, opaqueBackground, zIndex} = props;
    const style = {};

    if (zIndex) {
        style.zIndex = zIndex;
    }
    if (backgroundColor) {
        style.backgroundColor = backgroundColor;
    }

    const backdropContainerClassName = classNames({
        [styles.backdropContainer]: opaqueBackground,
        [styles.backdropContainerNoOpacity]: !opaqueBackground,
    });

    const modalBackdropClassName = classNames({
        [styles.modalBackdrop]: true,
    });

    const transitionClassNames = {
        enter: styles.transitionEnter,
        enterActive: styles.transitionEnterActive,
        enterDone: styles.transitionEnterDone,
        exit: styles.transitionExit,
        exitActive: styles.transitionExitActive,
        exitDone: styles.transitionExitDone,
    };

    return (
        <div className={backdropContainerClassName}>
            <CSSTransition timeout={0} appear={true} in={active} classNames={transitionClassNames}>
                <div className={modalBackdropClassName} onMouseDown={onMouseDown} style={style} />
            </CSSTransition>
        </div>
    );
}

ModalBackdrop.propTypes = {
    active: PropTypes.bool.isRequired,
    backgroundColor: PropTypes.string,
    onMouseDown: PropTypes.func.isRequired,
    opaqueBackground: PropTypes.bool,
    zIndex: PropTypes.number,
};

ModalBackdrop.defaultProps = {
    opaqueBackground: true,
}

export default ModalBackdrop;